import React from 'react'
import {
  Link,
  IconButton,
  List,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core'
import PowerSettingsNewOutlinedIcon from '@material-ui/icons/PowerSettingsNewOutlined'
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined'
import VideoCallOutlinedIcon from '@material-ui/icons/VideoCallOutlined'
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import DuoIcon from '@material-ui/icons/Duo'
import { Theme } from '../../styles'

const csrfToken = ''

export const ClientMenuList = ({ clientSlug }) => {
  return (
    <div>
      <Divider />
      <List className="list-style">
        <li>
          <Link className="link-style" href={'../' + clientSlug + '/posts'}>
            <ListItem button key="Posts">
              <ListItemIcon className="icon">
                <AssignmentOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Posts" />
            </ListItem>
          </Link>
          <Link className="link-style" href={'../' + clientSlug + '/new-post'}>
            <ListItem button key="Create New Post">
              <ListItemIcon className="icon">
                <AddOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Create New Post" />
            </ListItem>
          </Link>
          <Divider />
          <Link className="link-style" href={'../' + clientSlug + '/meetings'}>
            <ListItem button key="Meetings">
              <ListItemIcon className="icon">
                <DuoIcon />
              </ListItemIcon>
              <ListItemText primary="Meetings" />
            </ListItem>
          </Link>
          <Link
            className="link-style"
            href={'../' + clientSlug + '/new-meeting'}>
            <ListItem button key="Create New Meeting">
              <ListItemIcon className="icon">
                <VideoCallOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Create New Meeting" />
            </ListItem>
          </Link>
          <Divider />
          <Link className="link-style" href={'../' + clientSlug + '/library'}>
            <ListItem button key="Library">
              <ListItemIcon className="icon">
                <PhotoLibraryIcon />
              </ListItemIcon>
              <ListItemText primary="Library" />
            </ListItem>
          </Link>
          <Link
            className="link-style"
            href={'../' + clientSlug + '/attachments'}>
            <ListItem button key="Attachments">
              <ListItemIcon className="icon">
                <AttachFileIcon />
              </ListItemIcon>
              <ListItemText primary="Attachments" />
            </ListItem>
          </Link>
          <Divider />
          <ListItem button key="Toggle Theme">
            <ListItemIcon className="icon">
              <Theme />
            </ListItemIcon>
            <ListItemText primary="Toggle Theme" />
          </ListItem>
          <form action="../logout" method="POST">
            <input type="hidden" name="_token" value={csrfToken} />
            <ListItem button key="Logout">
              <ListItemIcon className="icon">
                <IconButton
                  style={{ color: '#e3342f', left: '-2px' }}
                  size="small"
                  aria-label="logout"
                  type="submit">
                  <PowerSettingsNewOutlinedIcon />
                </IconButton>
              </ListItemIcon>
              <ListItemText
                style={{ color: '#e3342f', paddingLeft: '2px' }}
                primary="Logout"
              />
            </ListItem>
          </form>
        </li>
      </List>
    </div>
  )
}

export default ClientMenuList
